import { render, staticRenderFns } from "./DashboardLatestComments.vue?vue&type=template&id=28722234&"
import script from "./DashboardLatestComments.vue?vue&type=script&lang=js&"
export * from "./DashboardLatestComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports